import React from 'react';
import moment from 'moment-timezone';
import { compose } from 'recompose';

import PropTypes from 'prop-types';
import config from '../../config';
import * as shapes from './shapes';
import withTimezone from '../auth/utils/withTimezone';
import withDateFormat from '../auth/utils/withDateFormat';

const Date = ({ date, children, timezone, format, automationId }) => {
  const dateMoment = moment.tz(date || children, timezone);
  const formatted = dateMoment.isValid() ? dateMoment.format(format) : '-';

  return <span data-automation-id={automationId}>{formatted}</span>;
};

Date.propTypes = {
  date: shapes.date,
  children: shapes.date,
  timezone: shapes.timezone,
  format: shapes.format,
  automationId: PropTypes.string,
};
Date.defaultProps = {
  date: '',
  children: '',
  timezone: config.defaultTimezone,
  format: config.dateFormat,
  automationId: null,
};

export default compose(withTimezone, withDateFormat('format'))(Date);
